import React, { useCallback, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ModalDialog } from './ModalDialog';

import { dialogMessageUpdated } from '../../actions';

import styles from './DialogMessage.module.css';

/**
 * As simple as a dialog message, nothing fancy.
 */
const DialogMessage = () => {
  const { t } = useTranslation('inboxAndDocs');
  const store = useSelector(({ common }) => ({
    common,
  }), shallowEqual);
  const { common } = store;
  const dispatch = useDispatch();

  const show = useMemo(() => !!common.dialogMessage.message,
    [common.dialogMessage]);

  const onClose = useCallback(() => {
    dispatch(dialogMessageUpdated({
      message: '',
      title: '',
    }));
  }, []);

  return (
    <ModalDialog cancelable onClose={onClose} show={show}>
      <div className={styles.mainContainer}>
        <h1>{t('errorModal.title')}</h1>

        <span>{t('errorModal.message')}</span>
      </div>
    </ModalDialog>
  );
};

const DialogMessageMemo = React.memo(DialogMessage);

export { DialogMessageMemo as DialogMessage };
